import { Controller } from "@hotwired/stimulus";
import Glide from "@glidejs/glide";

export default class extends Controller {
  connect() {
    this.variant = this.element.dataset.variant;

    let settings = {
      type: "carousel",
      perView: 3,
      rewind: false,
      bound: true,
      gap: 30,
      breakpoints: {
        1200: {
          perView: 2,
        },
        769: {
          perView: 1,
          peek: 40,
          gap: 16,
        },
      },
    };

    if (this.variant === "mini") {
      settings = {
        type: "carousel",
        perView: 4,
        rewind: false,
        bound: true,
        gap: 30,
        breakpoints: {
          1200: {
            perView: 3,
          },
          769: {
            perView: 2,
            peek: 40,
            gap: 16,
          },
          480: {
            perView: 1,
            peek: 40,
            gap: 16,
          },
        },
      };
    }

    this.slider = new Glide(this.element.querySelector(".glide"), settings);

    this.slider.on("run", () => {
      document.body.classList.add("swiping");
    });

    this.slider.on("run.after", () => {
      document.body.classList.remove("swiping");
    });

    this.slider.mount();
  }

  // maybeClick(evt) {
  //   if (this.swiping) {
  //     evt.preventDefault();
  //     evt.stopPropagation();
  //     return false;
  //   }

  //   return true;
  // }

  next() {
    this.slider.go(">");
  }

  prev() {
    this.slider.go("<");
  }

  disconnect() {
    this.slider.destroy();
  }
}
